import { useQuery } from '@tanstack/react-query';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { queries } from 'services/queries';

export const ReceptionConfigState = atom<General.ReceptionConfig | null | undefined>(null);

export const useReceptionConfig = () => {
  return useAtomValue(ReceptionConfigState);
};

export const useSetReceptionConfig = () => {
  return useSetAtom(ReceptionConfigState);
};

export const useReceptionConfigBootstrap = () => {
  const receptionConfig = useReceptionConfig();
  const setReceptionConfig = useSetReceptionConfig();
  const { data: userConfig } = useQuery({
    ...queries.accounts.userConfig,
    enabled: !receptionConfig,
  });

  useEffect(() => {
    if (userConfig?.receptionConfig) {
      setReceptionConfig(userConfig.receptionConfig);
    }
  }, [userConfig?.receptionConfig, setReceptionConfig]);
};
